interface InputObject {
  id: any,
  meta: {
    type: any
  },
  relatedAssets?: null | Array<any>
}

export const areThereInsightsWithoutSnippets = <T extends InputObject>(
  attachments: Array<T>
): boolean => {
  const highresRelated = attachments
    .filter(att => att.meta.type === 'highres')
    .reduce((acc, att) => ([
      ...acc,
      ...(att.relatedAssets ? att.relatedAssets : [])
    ]), [] as Array<T['id']>);
  const analyticIds = attachments
    .filter(att => att.meta.type === 'analytics')
    .map(att => att.id);

  return analyticIds.some(id => !highresRelated.includes(id));
};

